@if (authors[0]; as author) {
  <div class="flex flex-wrap items-center gap-md">
    @if (author.cta) {
      <cft-call-to-action class="group" [callToAction]="author.cta" callToActionStyle="content">
        <ng-container *ngTemplateOutlet="authorSection"></ng-container>
      </cft-call-to-action>
    } @else {
      <ng-container *ngTemplateOutlet="authorSection"></ng-container>
    }
    @if (author.partnerLogo && author.partnerCta) {
      <div class="overflow-hidden rounded-1 p-[4px] shadow-1">
        <cft-call-to-action [callToAction]="author.partnerCta" callToActionStyle="content">
          @if (portraitSize(author.partnerLogo); as size) {
            <img
              [ngSrc]="author.partnerLogo.url"
              [alt]="author.partnerLogo.title"
              [width]="size.width"
              [height]="size.height"
              class="h-[32px] w-full object-cover object-center"
            />
          }
        </cft-call-to-action>
      </div>
    }
  </div>
  <ng-template #authorSection>
    <div class="flex space-x-sm">
      <div>
        <span class="absolute ml-[20px] mt-[-10px]">
          <span class="inline-block h-[10px] w-[10px] rounded-full bg-white"></span>
          <fa-icon [icon]="verifiedIcon" class="ml-[-12px] text-green-500"></fa-icon>
        </span>
        @if (author.portrait) {
          <img
            [ngSrc]="author.portrait.url"
            [alt]="author.name"
            width="31"
            height="31"
            class="h-[31px] w-[31px] rounded-full border border-gold-500 object-cover object-center"
          />
        }
      </div>
      <div>
        <div class="text-xs font-semibold group-hover:underline">
          {{ author.name }}
          @if (author.cta) {
            <fa-icon [icon]="ctaIcon" class="ml-2xs"></fa-icon>
          }
        </div>
        @if (author.description) {
          <div class="text-xs text-grey-600">{{ author.description }}</div>
        }
      </div>
    </div>
  </ng-template>
}
